var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.001 96H320.023L367.407 24.875C370.657 20 371.032 13.625 368.282 8.5C365.406 3.25 360.03 0 354.154 0H157.995C151.994 0 146.618 3.25 143.868 8.5C140.992 13.625 141.367 20 144.618 24.875L192.001 96ZM320.023 128H192.001C-10.409 243.375 0.093 396.625 0.093 416C0.093 469 49.226 512 109.737 512H402.288C462.923 512 511.932 469 511.932 416C511.932 397 521.309 242.75 320.023 128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSack);
export default __webpack_public_path__ + "static/media/sack.539405eff18f8bfbba08a05655d23b7d.svg";
export { ForwardRef as ReactComponent };